

























































import { Component, Prop, Vue } from "vue-property-decorator";
import ColorPicker from '@/commonComponents/colorPicker/colorPicker.vue';

import * as def from "@/definitions";

import { Design } from "@/model/document2/page/surface/design/design";
import { Layer } from "@/model/document2/page/surface/design/layer/layer";
import { RectangleLayer } from "@/model/document2/page/surface/design/layer/rectangleLayer";
import { CircleLayer } from "@/model/document2/page/surface/design/layer/circleLayer";
import { PolygonLayer } from "@/model/document2/page/surface/design/layer/polygonLayer";

import { ColorConstruct } from "@/utilityModels/colorConstruct";

import ColorSelector from "@/commonComponents/colorSelector/colorSelector.vue"

import ValueEdit from "@/commonComponents/valueEdit/valueEdit.vue";
import AdjustedBalloon from '@/commonComponents/adjustedBalloon/adjustedBalloon.vue';

// ボタン
import ArrowDown from "../resources/arrowDown.vue";
import ArrowRight from "../resources/arrowRight.vue";
import CheckBoxOn from "../resources/checkBoxOn.vue";

import { MathHelper } from "@/helper/mathHelper";
import { ResourceHelper } from "@/helper/resourceHelper";
import { SpecialPatternLayer } from "@/model/document2/page/surface/design/layer/specialPatternLayer";

@Component({
  components: {
    ColorPicker,
    ValueEdit,
    ColorSelector,
    AdjustedBalloon,
    ArrowDown,
    ArrowRight,
    CheckBoxOn
  }
})
export default class MultiplePatternStyle extends Vue 
{
    @Prop() private design!: Design;

    // TextEditorのfocusLockを解除する
    private unlockTextEditorFocus()
    {
        // メッセージセンター取得
        var messageCenter = this.$store.getters.messageCenter;
        // メッセージセンターに送信
        messageCenter.send("unlock_text_editor_focus", null);
    }

    //↓↓↓↓↓開閉のアニメーション↓↓↓↓↓
    //こいつはpropsでもらいたい
    openStatus = {
        opend: true
    };

    multiplePatternStyleContentsOpenAnimate = false;
    multiplePatternStyleContentsCloseAnimate = false;

    open() {
        if (this.openStatus.opend) {
            this.multiplePatternStyleContentsCloseAnimate = true;
            setTimeout(() => {
                this.multiplePatternStyleContentsCloseAnimate = false;
                this.multiplePatternStyleContentsOpenAnimate = false;
                this.openStatus.opend = false;
            }, 200);
        } else {
            this.openStatus.opend = true;
            this.multiplePatternStyleContentsOpenAnimate = true;
            setTimeout(() => {
                this.multiplePatternStyleContentsOpenAnimate = false;
            }, 250);
        }
    }
    //↑↑↑↑↑開閉のアニメーション↑↑↑↑↑

    // すべてのレイヤーの特定のパラメータを取得する。
    // 一致していなければ null を返す
    private getLayerProperty(property : string) : any
    {
        var value : any = null;
        var isBreak : boolean = false;

        var allLayers = this.design.getSelectLayerWithoutGroup();
        for(var i = 0; i < allLayers.length; ++i)
        {
            var layer = allLayers[i];
            if(layer instanceof RectangleLayer || layer instanceof CircleLayer || layer instanceof PolygonLayer || layer instanceof SpecialPatternLayer)
            {
                var val = layer[property];
                if(val != null)
                {
                    if(value == null) { value = val; }
                    else if(typeof(value) == "number" && typeof(val) == "number" && MathHelper.equals(value, val)) { value = val; }
                    else if(value instanceof ColorConstruct && val instanceof ColorConstruct && value.equals(val)) { value = val; }
                    else if(value === val) { value = val; }
                    else 
                    { 
                        isBreak = true; 
                        break;
                    }
                }
            }
            if(isBreak) { break; }
        }

        if(isBreak) { return null; }

        return value;
    }

    // 線なし
    get noStroke() : boolean
    {
        let value = this.getLayerProperty("noStroke");
        return value != null && typeof value == 'boolean' ? value : false; 
    }
    
    switchNoStroke() {
        let value = this.getLayerProperty("noStroke");
        let currentValue = value != null && typeof value == 'boolean' ? value : false;
        let newValue = !currentValue;
        this.changeLayerProperty(newValue, "noStroke", true);
    }

    //↓↓↓↓↓カラーピッカー表示非表示↓↓↓↓↓
    //こいつはpropsでいらない
    isColorPickerVisible = false;
    showColorPicker() {
        this.isColorPickerVisible = true;
    }
    closeColorPicker() {
        this.isColorPickerVisible = false;
    }
    //↑↑↑↑↑カラーピッカー表示非表示↑↑↑↑↑

    get strokeColor() : ColorConstruct
    {
        var value = this.getLayerProperty("strokeColor");
        return value != null && value instanceof ColorConstruct ? value : new ColorConstruct();
    }

    get strokeColorStyle() 
    {
        var value = this.getLayerProperty("strokeColor");
        return value == null ? { "border-color" : "#000000", "border-width" : "1px", "border-style" : "solid" } : { "background-color" : value.hex }; 
    }

    private onChangingValue(value, tag)
    {
        this.changeLayerProperty(value, tag, false);
    }
    private onChangedValue(value, tag)
    {
        this.changeLayerProperty(value, tag, true);
    }

    private onChangingColor(color)
    {
        this.changeLayerProperty(color, "strokeColor", false);
    }
    private onChangedColor(color)
    {
        this.changeLayerProperty(color, "strokeColor", true);
    }

    //*** 線幅 ***//
    private get strokeWidth() 
    {
        var value = this.getLayerProperty("strokeWidth");
        return value != null && typeof(value) == "number" ? value : 1;
    }

    private changeLayerProperty(value: any, propertyName: string, isFinish : boolean = false, isOnce : boolean = false) 
    {
        var layers = this.design.getSelectLayerWithoutGroup();

        for(var i = 0; i < layers.length; ++i)
        {
            var layer = layers[i];

            this.$emit("doCommand", "changeLayerProperty", {
                layer : layer,
                propertyName : propertyName,
                value : value,
                isFinish : (isFinish || isOnce) && i == layers.length - 1,
                isOnce : false
            });
        }
    }

    private get userConfigColor(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }
    private get userConfigUnderLineColor(){
        var style = {
            backgroundColor : this.userConfigColor
        };
        return style;
    }

    private get userConfigTextAColorStyle(){
        var style = {
            color : this.$store.getters.userConfigColors.textAColor
        };
        return style;
    }

    private get userConfigTextBColorStyle(){
        var style = {
            color : this.$store.getters.userConfigColors.textBColor
        };
        return style;
    }

    getResource(file : string){
        return ResourceHelper.getResource(file);
    }
}
